export const IS_FIRST_TIME_LAUNCH_KEY = "isFirstTimeLaunch"